import { Link } from "react-router-dom";
import {
  Mail,
  Phone,
  MapPin,
  Instagram,
  Facebook,
  Twitter,
} from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#f5eee6] text-[#7a6e5f] pt-16 pb-8 px-4">
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-12">

        {/* About */}
        <div>
          <h3 className="text-xl font-serif font-bold mb-4">SuprSkin</h3>
          <p className="text-sm opacity-80">
            Personalised, sustainable skincare crafted for your unique glow. Clean ingredients, kind intentions.
          </p>
          <div className="flex gap-4 mt-4">
            <a href="#" aria-label="Instagram" className="hover:opacity-80">
              <Instagram className="w-5 h-5" />
            </a>
            <a href="#" aria-label="Facebook" className="hover:opacity-80">
              <Facebook className="w-5 h-5" />
            </a>
            <a href="#" aria-label="Twitter" className="hover:opacity-80">
              <Twitter className="w-5 h-5" />
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="font-semibold mb-4">Quick Links</h4>
          <ul className="space-y-2 text-sm">
            <li>
              <Link to="/products" className="hover:underline">Shop</Link>
            </li>
            <li>
              <Link to="/about" className="hover:underline">About Us</Link>
            </li>
            <li>
              <Link to="/contact" className="hover:underline">Contact</Link>
            </li>
            <li>
              <Link to="/articles" className="hover:underline">Articles</Link>
            </li>
          </ul>
        </div>

        {/* Customer Care */}
        <div>
          <h4 className="font-semibold mb-4">Customer Care</h4>
          <ul className="space-y-2 text-sm">
            <li>
              <a href="#" className="hover:underline">FAQs</a>
            </li>
            <li>
              <a href="#" className="hover:underline">Shipping Info</a>
            </li>
            <li>
              <a href="#" className="hover:underline">Returns</a>
            </li>
            <li>
              <a href="#" className="hover:underline">Privacy Policy</a>
            </li>
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h4 className="font-semibold mb-4">Contact Us</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2">
              <MapPin className="w-5 h-5" />
              <span>123 Glow Lane, Bali 80227</span>
            </li>
            <li className="flex items-start gap-2">
              <Phone className="w-5 h-5" />
              <span>+62 812 3456 7890</span>
            </li>
            <li className="flex items-start gap-2">
              <Mail className="w-5 h-5" />
              <span>hello@suprskin.com</span>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom Line */}
      <div className="border-t border-[#d6a89e] mt-12 pt-6 text-center text-sm text-[#7a6e5f] opacity-70">
        © {new Date().getFullYear()} SuprSkin. All rights reserved.
      </div>
    </footer>
  );
}
